import React from 'react';

import { useHandlerAdapter } from './text-input.helpers';
import { TextInputBox, TextInputField, TextInputIcon } from './text-input.styles';
import { TextInputProps } from './text-input.types';

export function TextInput(props: TextInputProps): JSX.Element | null {
  const {
    boxRef,
    fieldRef,
    icon,
    type = 'text',
    zohoInputName,
    name,
    value,
    placeholder,
    maxLength,
    isDisabled,
    isErrored,
    onChange,
    onFocus,
    onBlur,
    ...rest
  } = props;

  const handleChange = useHandlerAdapter(onChange);
  const handleFocus = useHandlerAdapter(onFocus);
  const handleBlur = useHandlerAdapter(onBlur);

  return (
    <TextInputBox {...rest} ref={boxRef}>
      <TextInputField
        siqatrib={zohoInputName}
        ref={fieldRef}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={isDisabled}
        $isErrored={isErrored}
        $hasValue={Boolean(value)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {icon && (
        <TextInputIcon>
          {icon}
        </TextInputIcon>
      )}
    </TextInputBox>
  );
}
